import { useCallback } from 'react'

// utils
import { getUserArtworks } from '../../utils/lib/utils'
import { 
  getUserBids,
  getAsksByUser,
  getBidBakeryArtworkNFTContract,
  getBidBakeryArtwork2NFTContract,
  getBidBakeryArtwork3NFTContract,
  getBidOneInchBakeNFTContract,
  getBidSfpNFTContract,
  getBidLoveNFTContract,
  getBidRacaNFTContract,
  getBidBscBakeNFTContract
} from '../../sushi/utils'

import { 
  getUserBidsByNFT,
  getUserAsksByNFT
} from '../../sushi/exchangeNFTs'


import {
  getExchangeNFTsContract,
  getExchangeNFTs2Contract
} from '../../sushi/exchangeNFTs'

import { userNftAddress } from '../../userType/userNftAddress'

import { useDigitalArtworkNftContract} from '../commonNft/useContract'

import { useMarketLevel } from '../../state/market/hooks'
import useYam from "../bakery/useYam"

import { MARKETTYPE, MARKETMULTITOKEN } from '../../constants/bakery/nft'

const useUserArtworks = (owner: string) => {
  const level = useMarketLevel()
  const sushi = useYam()

  // BakeryArtwork
  const bakeryArtworkNft = useDigitalArtworkNftContract(MARKETTYPE.BAKERYARTWORK)
  const bakeryNFTContract = getBidBakeryArtworkNFTContract(sushi)

  // BSCBAKEBakeryArtwork
  const bscbakeryArtworkNft = useDigitalArtworkNftContract(MARKETTYPE.BAKERYBSCARTWORK)
  const bscbakeryNFTContract = getBidBscBakeNFTContract(sushi)

  // MUSK & DOGE
  const muskDogeArtwork = useDigitalArtworkNftContract(MARKETTYPE.MUSKDOGE)
  const muskDogeNFTContract = getBidBakeryArtwork2NFTContract(sushi)

  // meme
  const memeArtwork = useDigitalArtworkNftContract(MARKETTYPE.MEME)
  const memeNFTContract = getBidBakeryArtwork3NFTContract(sushi)

  // oneInch
  const oneInchArtwork = useDigitalArtworkNftContract(MARKETTYPE.ONEINCH)
  const oneInchNFTContract = getBidOneInchBakeNFTContract(sushi)

  // SFP
  const sfpArtwork: any = useDigitalArtworkNftContract(MARKETTYPE.SFPARTWORK)
  const sfpNFTContract = getBidSfpNFTContract(sushi)

  // 520NFT
  const loveArtwork = useDigitalArtworkNftContract(MARKETTYPE.LOVE)
  const loveNFTContract = getBidLoveNFTContract(sushi)

  // RACANFT
  const racaArtwork = useDigitalArtworkNftContract(MARKETTYPE.RACANFT)
  const racaNFTContract = getBidRacaNFTContract(sushi)

  // RACAMUTITOKENNFT
  const racaMultiTokenArtwork = useDigitalArtworkNftContract(MARKETMULTITOKEN.RACAMULTITOKEN)
  const racaMultiTokenNFTContract = getExchangeNFTsContract(sushi)

  // MATRIXMULTITOKEN
  const matrixMultiTokenArtwork = useDigitalArtworkNftContract(MARKETMULTITOKEN.MATRIXMULTITOKEN)
  const matrixMultiTokenNFTContract = getExchangeNFTsContract(sushi)

  const exchangeNFTs2Contract = getExchangeNFTs2Contract(sushi)

  const getMyArtworks = useCallback(async () => {
      if (bakeryArtworkNft && muskDogeArtwork && memeArtwork && oneInchArtwork && sfpArtwork && loveArtwork && racaArtwork && racaMultiTokenArtwork &&matrixMultiTokenArtwork && bscbakeryArtworkNft && owner) {
      const userAllArr = {
        inwallet: [''],
        inBid: [''],
        onAuction: ['']
      }
      const [bakeryList, muskDogeList, memeList, oneInchList, sfpList, loveList, racaList, racaMultiList, matrixMultiList, bscBakeryList] = await Promise.all([
        getUserArtworks(bakeryArtworkNft, owner),
        getUserArtworks(muskDogeArtwork, owner),
        getUserArtworks(memeArtwork, owner),
        getUserArtworks(oneInchArtwork, owner),
        getUserArtworks(sfpArtwork, owner),
        getUserArtworks(loveArtwork, owner),
        getUserArtworks(racaArtwork, owner),
        getUserArtworks(racaMultiTokenArtwork, owner),
        getUserArtworks(matrixMultiTokenArtwork, owner),
        getUserArtworks(bscbakeryArtworkNft, owner)
      ])
      let racaMultiTokenNftAddress = userNftAddress(sushi, MARKETMULTITOKEN.RACAMULTITOKEN)
      let matrixMultiTokenNftAddress = userNftAddress(sushi, MARKETMULTITOKEN.MATRIXMULTITOKEN)
      let bakeryNftAddress = userNftAddress(sushi, MARKETTYPE.BAKERYARTWORK)
      let bakeryBSCNftAddress = userNftAddress(sushi, MARKETTYPE.BAKERYBSCARTWORK)
      let muskdogeNftAddress = userNftAddress(sushi, MARKETTYPE.MUSKDOGE)
      let memeNftAddress = userNftAddress(sushi, MARKETTYPE.MEME)
      let oneInchNftAddress = userNftAddress(sushi, MARKETTYPE.ONEINCH)
      let sfpNftAddress = userNftAddress(sushi, MARKETTYPE.SFPARTWORK)
      let loveNftAddress = userNftAddress(sushi, MARKETTYPE.LOVE)
      const [
        bakeryBid, muskDogebid, memeBid, 
        oneInchBid, sfpBid, loveBid, 
        racaBid, racaMultiBid, matrixMultiBid, bscBakeryBid,
        bakeryBidV3, muskDogebidV3, memeBidV3,
        oneInchBidV3, sfpBidV3, loveBidV3,
        racaBidV3, matrixMultiBidV3, bscBakeryBidV3
      ] = await Promise.all([
        getUserBids(bakeryNFTContract, owner),
        getUserBids(muskDogeNFTContract, owner),
        getUserBids(memeNFTContract, owner),
        getUserBids(oneInchNFTContract, owner),
        getUserBids(sfpNFTContract, owner),
        getUserBids(loveNFTContract, owner),
        getUserBids(racaNFTContract, owner),
        getUserBidsByNFT(racaMultiTokenNFTContract, racaMultiTokenNftAddress, owner),
        getUserBidsByNFT(matrixMultiTokenNFTContract, matrixMultiTokenNftAddress, owner),
        getUserBids(bscbakeryNFTContract, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, bakeryNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, muskdogeNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, memeNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, oneInchNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, sfpNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, loveNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, racaMultiTokenNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, matrixMultiTokenNftAddress, owner),
        getUserBidsByNFT(exchangeNFTs2Contract, bakeryBSCNftAddress, owner)
      ])
      
      const [
        bakeryAsk, muskDogeAsk, memeAsk, 
        oneInchAsk, sfpAsk, loveAsk, racaAsk, 
        racaMultiAsk, matrixMultiAsk, bscBakeryAsk,
        bakeryAskV3, muskDogeAskV3, memeAskV3,
        oneInchAskV3, sfpAskV3, loveAskV3,
        racaAskV3, matrixMultiAskV3, bscBakeryAskV3
      ] = await Promise.all([
        getAsksByUser(bakeryNFTContract, owner),
        getAsksByUser(muskDogeNFTContract, owner),
        getAsksByUser(memeNFTContract, owner),
        getAsksByUser(oneInchNFTContract, owner),
        getAsksByUser(sfpNFTContract, owner),
        getAsksByUser(loveNFTContract, owner),
        getAsksByUser(racaNFTContract, owner),
        getUserAsksByNFT(racaMultiTokenNFTContract, racaMultiTokenNftAddress, owner),
        getUserAsksByNFT(matrixMultiTokenNFTContract, matrixMultiTokenNftAddress, owner),
        getAsksByUser(bscbakeryNFTContract, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, bakeryNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, muskdogeNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, memeNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, oneInchNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, sfpNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, loveNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, racaMultiTokenNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, matrixMultiTokenNftAddress, owner),
        getUserAsksByNFT(exchangeNFTs2Contract, bakeryBSCNftAddress, owner),

      ])

      userAllArr.inwallet = bakeryList.map((d: any) => {
        return '3-' + d
      }).concat(
        muskDogeList.map((d: any) => {
          return '4-' + d
        })
      ).concat(
        memeList.map((d: any) => {
          return '5-' + d
        })
      ).concat(
        oneInchList.map((d: any) => {
          return '8-' + d
        })
      ).concat(
        sfpList.map((d: any) => {
          return '101-' + d
        })
      ).concat(
        loveList.map((d: any) => {
          return '105-' + d
        })
      ).concat(
        racaList.map((d: any) => {
          return '107-' + d
        })
      ).concat(
        racaMultiList.map((d: any) => {
          return '107-' + d
        })
      ).concat(
        matrixMultiList.map((d: any) => {
          return '113-' + d
        })
      ).concat(
        bscBakeryList.map((d: any) => {
          return '111-' + d
        })
      )

      userAllArr.inBid = bakeryBid.map((d: any) => {
        return '3-' + d[0]
      }).concat(
        bakeryBidV3.map((d: any) => {
          return '3-' + d.tokenId
        })
      ).concat(
        muskDogebid.map((d: any) => {
          return '4-' + d[0]
        })
      ).concat(
        muskDogebidV3.map((d: any) => {
          return '4-' + d.tokenId
        })
      ).concat(
        memeBid.map((d: any) => {
          return '5-' + d[0]
        })
      ).concat(
        memeBidV3.map((d: any) => {
          return '5-' + d.tokenId
        })
      ).concat(
        oneInchBid.map((d: any) => {
          return '8-' + d[0]
        })
      ).concat(
        oneInchBidV3.map((d: any) => {
          return '8-' + d.tokenId
        })
      ).concat(
        sfpBidV3.map((d: any) => {
          return '101-' + d.tokenId
        })
      ).concat(
        sfpBid.map((d: any) => {
          return '101-' + d[0]
        })
      ).concat(
        loveBid.map((d: any) => {
          return '105-' + d[0]
        })
      ).concat(
        loveBidV3.map((d: any) => {
          return '105-' + d.tokenId
        })
      ).concat(
        racaBid.map((d: any) => {
          return '107-' + d[0]
        })
      ).concat(
        racaBidV3.map((d: any) => {
          return '107-' + d.tokenId
        })
      ).concat(
        racaMultiBid.map((d: any) => {
          return '107-' + d.tokenId
        })
      ).concat(
        matrixMultiBid.map((d: any) => {
          return '113-' + d.tokenId
        })
      ).concat(
        matrixMultiBidV3.map((d: any) => {
          return '113-' + d.tokenId
        })
      ).concat(
        bscBakeryBid.map((d: any) => {
          return '111-' + d[0]
        })
      ).concat(
        bscBakeryBidV3.map((d: any) => {
          return '111-' + d.tokenId
        })
      )

      userAllArr.onAuction = bakeryAsk.map((d: any) => {
        return '3-' + d[0]
      }).concat(
        bakeryAskV3.map((d: any) => {
          return '4-' + d.tokenId
        })
      ).concat(
        muskDogeAsk.map((d: any) => {
          return '4-' + d[0]
        })
      ).concat(
        muskDogeAskV3.map((d: any) => {
          return '4-' + d.tokenId
        })
      ).concat(
        memeAsk.map((d: any) => {
          return '5-' + d[0]
        })
      ).concat(
        memeAskV3.map((d: any) => {
          return '5-' + d.tokenId
        })
      ).concat(
        oneInchAsk.map((d: any) => {
          return '8-' + d[0]
        })
      ).concat(
        oneInchAskV3.map((d: any) => {
          return '8-' + d.tokenId
        })
      ).concat(
        sfpAsk.map((d: any) => {
          return '101-' + d[0]
        })
      ).concat(
        sfpAskV3.map((d: any) => {
          return '101-' + d.tokenId
        })
      ).concat(
        loveAsk.map((d: any) => {
          return '105-' + d[0]
        })
      ).concat(
        loveAskV3.map((d: any) => {
          return '105-' + d.tokenId
        })
      ).concat(
        racaAsk.map((d: any) => {
          return '107-' + d[0]
        })
      ).concat(
        racaAskV3.map((d: any) => {
          return '107-' + d.tokenId
        })
      ).concat(
        racaMultiAsk.map((d: any) => {
          return '107-' + d.tokenId
        })
      ).concat(
        matrixMultiAsk.map((d: any) => {
          return '113-' + d.tokenId
        })
      ).concat(
        matrixMultiAskV3.map((d: any) => {
          return '113-' + d.tokenId
        })
      ).concat(
        bscBakeryAsk.map((d: any) => {
          return '111-' + d[0]
        })
      ).concat(
        bscBakeryAskV3.map((d: any) => {
          return '111-' + d.tokenId
        })
      )

      return userAllArr
    }
    return {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [owner, bakeryArtworkNft, level])

  return getMyArtworks
}

export default useUserArtworks